import React, { Component } from 'react';
import './index.css';

class ActivityRule extends Component {
    render () {
        return (
            <div className="ActivityRule">
                <div className="ActivityRule-title">活动规则:</div>
                <ul className="ActivityRule-explain">
                    <li>1.支付200鱼丸可报名参加活动，获得次日打卡机会；</li>
                    <li>2.报名成功后在次日19:00-21:00回到签到页打卡，即可随机（有概率低于200鱼丸）瓜分奖池内全部鱼丸；</li>
                    <li>3.奖池由前一天参加活动用户的报名鱼丸组成，当期全部瓜分给用户，斗鱼平台不收取任何费用，未在打卡时间内打卡，报名鱼丸不退回；</li>
                    <li>4.每日瓜分鱼丸数额于当日21:00后开始结算，22:00前自动发放至个人账户，请留意站内信通知，或者在打卡记录内查看。</li>
                </ul>
            </div>
        );
    }
}

export default ActivityRule;
